import classes from './CompareButton.module.css';
import { useContext } from 'react';

// IMPORT FONTAWESOME ICONS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
import { useBrandFind } from '../../hooks/useFinders';
import CompareContext from '../../store/compare-context';
import { globals } from '../../data/global-vars';

function CompareButton(props) {
  const params = useParams();
  const brand = params.brand;
  const brandObject = useBrandFind(brand);
  let primeColor;
  if (props.primeColor) primeColor = props.primeColor;
  else if (brandObject) primeColor = brandObject.primeColor;
  else primeColor = 'var(--vw-color)';
  const compareCtx = useContext(CompareContext);
  const carIdLink = compareCtx.cars
    .map((c) => c + '&')
    .join('')
    .slice(0, -1);

  if (compareCtx.cars.length === 0) return null;
  else {
    return (
      <Link
        to={`/${brandObject.url}/${globals.PAGES.VERGLEICH.url}/${carIdLink}`}
      >
        <div className={classes.compareButton}>
          <FontAwesomeIcon
            className={classes.icon}
            icon={faHeart}
            style={{ color: primeColor }}
          />
          <span className={classes.compareText}>
            Vergleichen ({compareCtx.cars.length})
          </span>
          <span className={classes.counter}>{compareCtx.cars.length}</span>
        </div>
      </Link>
    );
  }
}

export default CompareButton;
